import { render } from "./Photo.vue?vue&type=template&id=a95dca60&scoped=true&ts=true"
import script from "./Photo.vue?vue&type=script&lang=ts"
export * from "./Photo.vue?vue&type=script&lang=ts"

import "./Photo.vue?vue&type=style&index=0&id=a95dca60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95dca60"]])

export default __exports__